import { render } from "./HospitalTable.vue?vue&type=template&id=d350dc72&scoped=true"
import script from "./HospitalTable.vue?vue&type=script&lang=js"
export * from "./HospitalTable.vue?vue&type=script&lang=js"

import "./HospitalTable.vue?vue&type=style&index=0&id=d350dc72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d350dc72"]])

export default __exports__